import React, { useState, useEffect, useRef } from 'react';
import * as d3 from 'd3';
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Toast from 'react-bootstrap/Toast';

import RangeSlider from 'react-bootstrap-range-slider';
import SongPlayModal from './SongPlayModal';

import { useContext } from 'react';
import { GlobalStateContext } from './GlobalState';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';



const Squeeze = (props) => {
  const [data, setData] = useState([]);
  const [dataBeforeFilter, setDataBeforeFilter] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const svgRef = useRef(null);
  const [sortOrder, setSortOrder] = useState('asc');
  const [minFuntorun, setMinFuntorun] = useState(0); // Add state for minimum funtorun
  const [maxFuntorun, setMaxFuntorun] = useState(200); // Add state for maximum funtorun
  const [targetMinutes, setTargetMinutes] = useState(200); // Add state for target duration

  const { globalList, addListToGlobalList } = useContext(GlobalStateContext);
  const [showToast, setShowToast] = useState(false);
  const [toastPosition, setToastPosition] = useState({ top: 0, left: 0 });

  const navigate = useNavigate();


  // Add a function to filter data based on the funtorun range
  const filterDataByFuntorun = (min, max) => {
    return dataBeforeFilter.filter(d => d.funtorun >= min && d.funtorun <= max);
  };
  const handleDelete = (index) => {
    const newSongs = [...data];
    newSongs.splice(index, 1);
    setData(newSongs);
  };

  // Add functions to handle funtorun range changes
  const handleMinFuntorunChange = (e) => {
    setMinFuntorun(e.target.value);
    const filteredData = filterDataByFuntorun(minFuntorun, maxFuntorun);
    setData(filteredData)
    renderChart(filteredData)
  };

  const handleMaxFuntorunChange = (e) => {
    setMaxFuntorun(e.target.value);
    const filteredData = filterDataByFuntorun(minFuntorun, maxFuntorun);
    setData(filteredData)
    renderChart(filteredData)
  };

  const filterDataByDuration = (data, targetMins) => {
    let currentDuration = 0;
    return data.filter(song => {
      if (currentDuration + (song.duration_s / 60) <= targetMins) {
        currentDuration += song.duration_s / 60;
        return true;
      }
      return false;
    });
  };

  const handleTargetMinutesChange = (e) => {
    const newTarget = parseInt(e.target.value);
    setTargetMinutes(newTarget);

    // First apply the funtorun filter
    const funtorunFiltered = filterDataByFuntorun(minFuntorun, maxFuntorun);

    // Then apply the duration filter to the funtorun-filtered data
    let currentDuration = 0;
    const filteredData = funtorunFiltered.filter(song => {
      if (currentDuration + (song.duration_s / 60) <= newTarget) {
        currentDuration += song.duration_s / 60;
        return true;
      }
      return false;
    });

    setData(filteredData);
    renderChart(filteredData);
  };
  const handleSortAsc = () => {
    setSortOrder('asc');
    const sortedData = [...data].sort((a, b) => {
      return a.funtorun - b.funtorun;
    });
    setData(sortedData);
    renderChart(sortedData); // Call the renderChart function with the sorted data

  };

  const handleSortDesc = () => {
    setSortOrder('desc');
    const sortedData = [...data].sort((a, b) => {
      return b.funtorun - a.funtorun;
    });
    setData(sortedData);
    renderChart(sortedData); // Call the renderChart function with the sorted data
  };

  const handleSortHalfAscAndHalfDesc = () => {
    const sortedData = [...data].sort((a, b) => a.funtorun - b.funtorun);
    const totalDuration = sortedData.reduce((sum, song) => sum + song.duration_s, 0);
    const halfDuration = Math.floor(totalDuration / 2);

    let currentDuration = 0;
    let halfIndex = -1;
    for (let i = 0; i < sortedData.length; i++) {
      currentDuration += sortedData[i].duration_s;
      if (currentDuration >= halfDuration) {
        halfIndex = i;
        break;
      }
    }

    const firstHalf = sortedData.slice(0, halfIndex + 1);
    const secondHalf = sortedData.slice(halfIndex + 1).reverse();
    const sortedHalfData = [...firstHalf, ...secondHalf];

    setData(sortedHalfData);
    renderChart(sortedData); // Call the renderChart function with the sorted data
  };
  const handleSortFartlek1 = () => {
    const sortedData = [...data].sort((a, b) => a.funtorun - b.funtorun);


    let mixed = [];
    let i2 = (sortedData.length - 1);
    for (let i = 0; i < (sortedData.length / 2); i++) {

      if (i < ((sortedData.length / 2) << 0)) {
        mixed.push(sortedData[i]);
        mixed.push(sortedData[i2]);
        i2 = i2 - 1
      }
      else {
        i = i + 1;
        mixed.push(sortedData[i]);
      }
    }

    setData(mixed);
    renderChart(mixed); // Call the renderChart function with the sorted data
  };

  const handleAddList = () => {

    addListToGlobalList(data);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 1000); // Hide the toast after 3 seconds.

    setTimeout(() => {
      //props.closingModal();
      // window.location.href = '/mixandsave';  // Redirect to Mix&Save 
      navigate('/mixandsave');  // Use React Router navigation     
    }, 3000);
  };

  const handleAddSongToGlobalList = (song, index, event) => {
    addListToGlobalList([song]); // Add single song as an array of one item
    const rect = event.target.getBoundingClientRect();
    setToastPosition({
      top: rect.top - 60,  // Position above the plus icon
      left: rect.left
    });
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      handleDelete(index); // Remove the song from the current list after toast disappears
    }, 1000);
  };


  const renderChart = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return; // Exit if data is not an array or is empty
    }
    const svg = d3.select(svgRef.current);
    svg.selectAll('*').remove(); // Clear previous chart elements
    const margin = { top: 20, right: 20, bottom: 30, left: 50 };
    const width = svg.attr('width') - margin.left - margin.right;
    const height = svg.attr('height') - margin.top - margin.bottom;
    const x = d3.scaleBand()
      .range([0, width])
      .domain(data.map(d => d.name))
      .padding(0.1);
    const y = d3.scaleLinear()
      .range([height, 0])
      .domain([0, d3.max(data, d => d.funtorun)]);
    svg.append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`)
      .call(d3.axisLeft(y));
    svg.selectAll('.lollipop')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', 'lollipop')
      .attr('cx', d => x(d.name) + x.bandwidth() / 2 + margin.left)
      .attr('cy', d => y(d.funtorun) + margin.top)
      .attr('r', 5)
      .attr('fill', 'steelblue');
  };

  useEffect(() => {
    setIsLoading(true);
    setData(props.list);
    setDataBeforeFilter(props.list);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      renderChart(data);
    }
  }, [data, isLoading]);

  const totalDurationInSeconds = Array.isArray(data) && data.length > 0 ? data.reduce((acc, song) => acc + song.duration_s, 0) : 0;
  const totalDurationInMinutes = Math.round(totalDurationInSeconds / 60);

  return (
    <div className="container" style={{ backgroundColor: 'black', color: 'white' }}>

      {isLoading ? (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : (
        <>
          {/* Add button for sorting */}
          <p>Total Duration:
            {totalDurationInMinutes}
            {" minutes"}
          </p>
          <svg ref={svgRef} width={300} height={200} />

          <div style={{ maxWidth: '300px' }} align="center">
            <div className="row" >
              <div className="col-3">
                <label>Run Boost </label>
              </div>
              <div className="col-9">
                <div className="row">

                  <div className="col-5">
                    <label>Min: {minFuntorun}</label>
                  </div>
                  <div className="col-7">
                    <RangeSlider
                      value={minFuntorun}
                      min={0}
                      max={200}
                      onChange={handleMinFuntorunChange}
                      tooltip={'off'}
                      variant={'primary'}
                      style={{ width: '120px' }}
                    />
                  </div>


                </div>
                <div className="row">
                  <div className="col-5">
                    <label>Max : {maxFuntorun}</label>
                  </div>
                  <div className="col-7">
                    <RangeSlider
                      value={maxFuntorun}
                      min={0}
                      max={200}
                      onChange={handleMaxFuntorunChange}
                      tooltip={'off'}
                      variant={'primary'}
                      style={{ width: '120px' }}
                    />
                  </div>

                </div>
              </div>

              <br />
            </div>
            <br /><br />
            <div className="row">
              <div className="col-3">
                <label>Target Minutes: </label>
              </div>
              <div className="col-9">
                <div className="row">
                  <div className="col-5">
                    <label>{targetMinutes} min</label>
                  </div>
                  <div className="col-7">
                    <RangeSlider
                      value={targetMinutes}
                      min={1}
                      max={200}
                      onChange={handleTargetMinutesChange}
                      tooltip={'off'}
                      variant={'success'}
                      style={{ width: '120px' }}
                    />
                  </div>
                </div>
              </div>
            </div>








            {/*}
            <div className="row">
              <div className="col-3">
                <label>Run Shape: </label>
              </div>
              <div className="col-2">
                <Button variant="primary" onClick={handleSortAsc}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-graph-up-arrow"
                    viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z" />
                  </svg>
                  Up
                </Button>
              </div>
              <div className="col-3">
                <Button variant="primary" onClick={handleSortDesc}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-graph-down-arrow" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M0 0h1v15h15v1H0V0Zm10 11.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v2.6l-3.613-4.417a.5.5 0 0 0-.74-.037L7.06 8.233 3.404 3.206a.5.5 0 0 0-.808.588l4 5.5a.5.5 0 0 0 .758.06l2.609-2.61L13.445 11H10.5a.5.5 0 0 0-.5.5Z" />
                  </svg>
                  Down
                </Button>
              </div>
              <div className="col-2">
                <Button variant="primary" onClick={handleSortHalfAscAndHalfDesc}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-rainbow"
                    viewBox="0 0 16 16">
                    <path d="M8 4.5a7 7 0 0 0-7 7 .5.5 0 0 1-1 0 8 8 0 1 1 16 0 .5.5 0 0 1-1 0 7 7 0 0 0-7-7zm0 2a5 5 0 0 0-5 5 .5.5 0 0 1-1 0 6 6 0 1 1 12 0 .5.5 0 0 1-1 0 5 5 0 0 0-5-5zm0 2a3 3 0 0 0-3 3 .5.5 0 0 1-1 0 4 4 0 1 1 8 0 .5.5 0 0 1-1 0 3 3 0 0 0-3-3zm0 2a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 2 2 0 1 1 4 0 .5.5 0 0 1-1 0 1 1 0 0 0-1-1z" />
                  </svg>
                  Arc
                </Button>
              </div>
              <div className="col-2">
                <Button variant="primary" onClick={handleSortFartlek1}>
                  <i class="bi bi-arrow-down-up" title="Alternate Fast and slow"></i> Fartlek
                </Button>
              </div>

            </div>
{*/}
          </div>
          <br />
          <div className="d-flex gap-2">
            <Button variant="success" onClick={handleAddList}>
              Load all songs
            </Button>
            <Button variant="info" onClick={() => {
              // Navigate to chat with current playlist context
              // We use window.open to open in a new tab/window or just navigate
              // For now, let's navigate to a chat route or toggle a modal
              // Since the requirement is "Open in Chat", let's assume a separate page or modal
              // But wait, the ChatBox is likely on a separate page or a global component.
              // Let's assume we navigate to /chat (which might need to be added to routes)
              // OR we can use the existing ChatBox if it's available.
              // Given the architecture, let's navigate to a new route /chat-context
              // passing the state.
              navigate('/chat', { state: { systemContext: data } });
            }}>
              <i className="bi bi-chat-dots"></i> Open in Chat
            </Button>
          </div>

          <br />

          <Table responsive bordered variant="dark">
            <thead>
              <tr>
                <th style={{ color: 'steelblue' }}>Name</th>
                <th style={{ color: 'steelblue' }}></th>
                <th style={{ color: 'steelblue' }}>Preview</th>
                <th style={{ color: 'steelblue' }}>Run Boost</th>
                <th style={{ color: 'steelblue' }}>Add</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data) && data.map((d, i) => (
                <tr key={i}>
                  <td>{d.artist}-<span style={{ color: 'steelblue' }}>{d.name}</span></td>
                  <td>
                    <i className="bi bi-x-circle-fill" style={{ fontSize: '1.5em' }} onClick={() => handleDelete(i)}></i>
                  </td>
                  <td>
                    <SongPlayModal classvalue="bi bi-music-note-beamed" linkText="P" songId={d.id} modalTitle={d.artist + "-" + d.name} width="250" height="100" />
                  </td>
                  <td>{Math.round(d.funtorun)}</td>
                  <td>
                    <i className="bi bi-plus-circle-fill"
                      style={{ fontSize: '1.5em', cursor: 'pointer' }}
                      onClick={(e) => handleAddSongToGlobalList(d, i, e)}
                      title="Load song"
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <br />
          <Toast
            show={showToast}
            onClose={() => setShowToast(false)}
            delay={500}
            autohide
            style={{
              position: 'fixed',
              top: toastPosition.top,
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 9999
            }}
          >
            <Toast.Header>
              <strong className="me-auto">Success</strong>
            </Toast.Header>
            <Toast.Body style={{ color: "black" }}>
              Songs loaded
            </Toast.Body>
          </Toast>

          <Button variant="success" onClick={handleAddList}>
            Load all songs
          </Button>

          <br /><br />
          <div style={{ padding: '40px' }}>
            Songs metadata provided by Spotify.     <a href="https://open.spotify.com/" target="_blank" rel="noreferrer"> <img src={require("./s2rimages/listenonspotify.png")} alt="Spotify site" width="160px" /></a>
          </div>



        </>
      )
      }
    </div >
  );
};




export default Squeeze;
